export enum DateTimeOptionValue {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    LAST_7_DAYS = 'LAST_7_DAYS',
    THIS_MONTH = 'THIS_MONTH',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_MONTH = 'LAST_MONTH',
    THIS_QUARTER = 'THIS_QUARTER',
    THIS_YEAR = 'THIS_YEAR',
    LAST_YEAR = 'LAST_YEAR',
    CUSTOM = 'CUSTOM',
}

export interface DateTimeOptionQueryParams {
    interval: DateTimeOptionValue,
    startDate?: string,
    endDate?: string
}